import { Location } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Temporal } from '@js-temporal/polyfill';
import { db } from 'src/app/db/db';
import { ELocalisationRejet } from 'src/app/domain/EAU/enum/location-rejet';
import { ETypeMateriel } from 'src/app/domain/EAU/enum/materiel-type';
import { MeasureEau } from 'src/app/domain/EAU/measure-eau';
import { EditTextBoxDialog } from 'src/app/tools/ui/edit-text-box/edit-text-box';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { StringConverter } from 'src/app/tools/ui/string-converter';

@Component({
    selector: 'app-eau',
    templateUrl: './eau.component.html',
    styleUrls: ['./eau.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EauComponent implements OnInit {
    public LocalisationRejetList: string[] = Object.values(ELocalisationRejet)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getLocalisationRejetName(x));

    public TypeMaterielList: string[] = Object.values(ETypeMateriel)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getTypeMaterielName(x));

    public Model: MeasureEau = new MeasureEau()
    public samplingTime!: string;
    SamplingDate: Date = new Date();
    private code: string = '';

    DateChangementFiltre: Date = new Date();

    constructor(
        private dialog: MatDialog,
        private location: Location,
        private snackBar: MatSnackBar,
        private route: ActivatedRoute) { }

    async ngOnInit(): Promise<void> {
        this.code = this.route.snapshot.params?.['code'];

        if (this.code) {
            this.Model = await db.getMeasureEauByCode(this.code);
            // this.Model.SamplingTime = Temporal.Now.plainTimeISO();
            if (this.Model.MaterielEau?.DateChangementFiltre) {
                this.DateChangementFiltre = new Date(this.Model.MaterielEau.DateChangementFiltre.year, this.Model.MaterielEau.DateChangementFiltre.month - 1, this.Model.MaterielEau.DateChangementFiltre.day);
            } else { // Set the default date to now
                this.Model.MaterielEau.DateChangementFiltre = Temporal.PlainDate.from({ year: this.DateChangementFiltre.getFullYear(), day: this.DateChangementFiltre.getDate(), month: this.DateChangementFiltre.getMonth() + 1 });;
            }
            this.SamplingDate = new Date();
            this.SamplingDate.setHours(this.Model.SamplingTime!.hour, this.Model.SamplingTime!.minute);
            this.setTimeSamplingDate();
        }
    }

    timeSetSamplingDate(event: string) {
        const time = event.split(':');

        this.SamplingDate = new Date(this.SamplingDate);
        this.SamplingDate.setHours(Number(time[0]), Number(time[1]));
        this.Model.SamplingTime = Temporal.PlainTime.from({ hour: this.SamplingDate.getHours(), minute: this.SamplingDate.getMinutes(), microsecond: 0 });
        this.setTimeSamplingDate();
    }

    setTimeSamplingDate() {
        this.samplingTime = `${this.SamplingDate.getHours()}:${this.SamplingDate.getMinutes()}`;
    }

    dateChangementFiltreChanged(event: MatDatepickerInputEvent<Date>) {
        if (!this.Model.MaterielEau) {
            return;
        }

        this.Model.MaterielEau.DateChangementFiltre = Temporal.PlainDate.from({ year: this.DateChangementFiltre.getFullYear(), day: this.DateChangementFiltre.getDate(), month: this.DateChangementFiltre.getMonth() + 1 });
    }

    cancelMeasure() {
        const dialogRef = this.dialog.open(EditTextBoxDialog, { data: { title: 'Veuillez indiquer le motif de l\'annulation', withCancelButton: true } });
        dialogRef.afterClosed().subscribe(async (result: string) => {
            if (result) {
                await db.cancelMeasureEau(this.Model, result);
                NotificationManager.handleSuccess('Mesure annulée', this.snackBar);
                this.location.back()
            }
        })
    }

    async save() {
        const success = await db.updateMeasureEau(this.Model);
        if (success) {
            NotificationManager.handleSuccess('Mesure enregistrée', this.snackBar);
            this.location.back();
        } else if (!success) {
            NotificationManager.handleError('Wasted Bro!', this.snackBar);
        }
    }
}
